import styled from 'styled-components';
import { CustomThemeToken } from '@/theme';

interface ContentWithSliderContainerProps {
  theme: { token: CustomThemeToken };
}

export const ContentWithSliderContainer = styled.div<ContentWithSliderContainerProps>`
  display: flex;
  flex-direction: column;

  .details-widget-slider {
    padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingMD + token.paddingXL }px
      ${({ theme: { token } }) => token.padding}px;

    .slider-container {
      padding: 0 ${({ theme: { token } }) => token.paddingXL}px;
      max-height: ${({ theme: { token } }) => token.marginMD + token.marginLG}px;
      max-width: 85%;

      .value-arrow-block {
      }

      .value {
        margin-bottom: 0;

        .value-content {
          font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
        }

        .units-sign {
          bottom: 4px;
        }
      }

      .slider {
        &:before {
          margin-left: -16.2601626%;
          width: 16.2601626%;
          border-top-left-radius: ${({ theme: { token } }) => token.borderRadiusXS}px;
          border-bottom-left-radius: ${({ theme: { token } }) => token.borderRadiusXS}px;
        }

        &:after {
          margin-right: -16.2601626%;
          width: 16.2601626%;
          border-top-right-radius: ${({ theme: { token } }) => token.borderRadiusXS}px;
          border-bottom-right-radius: ${({ theme: { token } }) => token.borderRadiusXS}px;
        }
      }

      .triangle {
        height: 8px;
        width: 12px;
        margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
      }

      .points {
        .point-value {
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
          margin-top: ${({ theme: { token } }) => token.marginXXS}px;
        }

        .label {
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        }
      }
    }
  }
`;
